import { __get__ } from './db';

export function get(cubeId: CubeId): DragCubeNode {
    return __get__(cubeId);
}
